import './dropdown-nav.js'
import './aos-init.js'
import './accordions.js'
import './card-text-reveal.js'
import './carousels.js'
import './cookies.js'
import './dialog-modals.js'
import './equalheights.js'
import './gsap.js'
import './hero-video.js'
import './mobile-nav.js'
import './modal.js'
import './notification-strip.js'
import './side-menu-location.js'
import './tables.js'
import './video.js'

// check js is running
document.documentElement.classList.remove('no-js')
